import React, { useEffect, useState, useContext } from "react";
import { Row, Col } from "react-bootstrap";
import Fade from "react-reveal/Fade";
import { CryptoItems } from "../Trade/CryptoItems";
import { FiArrowUpRight, FiArrowDownLeft } from "react-icons/fi";
import ItemWrapper from "./ItemWrapper";
import {Link} from 'react-router-dom';
import { Container } from 'react-bootstrap';
import Logo from '../../components/assets/logo.png';
import { UserContext } from "../../components/UserContext";
import SellCheckOut from "./SellCheckOut";
import axios from "axios"
import back from "../../components/assets/bx_bx-arrow-back.png";
import { useSnackbar } from "notistack"
import BTCRate from "../../components/BTCRate"
import TAC from "../../components/TandC"
import useFetch from "../../hooks/useFetch"

const TradeSell = (props) => {
  const currencies = useContext(UserContext);
  const { enqueueSnackbar } = useSnackbar();
  const [amount, setAmount] = useState("");
  const [currency, setCurrency] = useState([]);
  const [checked, setChecked] = useState(false);
  const [apiValue, setApiValue] = useState(0);
  const [usd, setUsd] = useState("");
  const [min, setMin] = useState(false);
  const [minValue, setMinValue] = useState("");
  const [totalAmount,setTotalAmount] = useState(0);
  const [email,setEmail] = useState("");
  const [buyRate,setBuyRate] = useState(0)
  const [banks,setBanks] = useState([]);
  const [rates,setRates] = useState([]);
  const {response:list} = useFetch()

// eslint-disable-next-line
  String.prototype.removeCharAt = function (i) {
    var tmp = this.split(''); 
    tmp.splice(i - 1 , 1);
    return tmp.join('');
}
  const formatAmount = price =>{
    let increasedPrice;
    let newIncreasedPrice;
    if(price.toString().length ===4 ){

            increasedPrice = price.toString().replace(/(\d{1})/g, "$1,").replace(/(^\s+|\s+$)/, "")
            newIncreasedPrice = increasedPrice.removeCharAt(4).removeCharAt(5).removeCharAt(6)
        }
    else if(price.toString().length ===5 ){

        increasedPrice = price.toString().replace(/(\d{2})/g, "$1,").replace(/(^\s+|\s+$)/, "")
        newIncreasedPrice = increasedPrice.removeCharAt(6)
    }
    else if(price.toString().length === 6 ){
        increasedPrice = price.toString().replace(/(\d{3})/g, "$1,").replace(/(^\s+|\s+$)/, "")
        newIncreasedPrice = increasedPrice.removeCharAt(8)
    }
    else  if(price.toString().length === 7 ){
        increasedPrice = price.toString().replace(/(\d{1})/g, "$1,").replace(/(^\s+|\s+$)/, "")
        newIncreasedPrice = increasedPrice.removeCharAt(4).removeCharAt(5).removeCharAt(8).removeCharAt(9).removeCharAt(10)
    }
    else{
      newIncreasedPrice= price
    }
    return newIncreasedPrice
}

  useEffect(() => {
    let short = currency.short
    const getPrice = ()=>{
   axios
     .get(`https://min-api.cryptocompare.com/data/pricemulti?fsyms=${short}&tsyms=${checked?"NGN":"USD"}`)
     .then((res) => {
       const cryptos = res.data;
       if (cryptos) setApiValue(cryptos[short]["USD"]);
     }).catch(_er=>
      enqueueSnackbar("No internet connection", {
        variant: "error",
        anchorOrigin: {
          vertical: "bottom",
          horizontal: "right",
        },
      }))
   }
   if(short)
   getPrice()
 }, [currencies,currency,checked,enqueueSnackbar]);
  useEffect(() => {
    let selectedCurrency = CryptoItems.filter(
      (curr) => curr.id === parseInt(props.match.params.currency)
    );
    
    const real = list.filter((el)=>el.Crypto === selectedCurrency[0].short)
    setRates(real)
    if(real.length >0){
     if(!isNaN(real[0].Sell)) 
      setBuyRate(real[0].Sell)
    }
    setCurrency(selectedCurrency[0]);
    axios.get("https://api.paystack.co/bank").then((res)=>setBanks(res.data.data))
  }, [props.match.params.currency,list]);
  const [proceed, setProceed] = useState(false);


  const onSwitch =(e)=>{
    if(e.target.value === "NGN")
    setChecked(true)
    if(e.target.value === "NGN"){
      setTotalAmount(prev =>  Math.round(prev*buyRate))
      setUsd(prev => prev*buyRate)
    }
    else{
      setChecked(false)
      setTotalAmount(prev => Math.round(prev/buyRate))
      setUsd(prev => Math.round(prev/buyRate))
    }
  }
  
  const handleUsdChange = e=>{
    if(!isNaN(e.target.value)){
      let amountss =checked ? (e.target.value/(apiValue*buyRate)).toString().slice(0,8) :(e.target.value/apiValue).toString().slice(0,8)

     if((!checked && e.target.value > 5000) || (checked && e.target.value > (5000*buyRate))){
      setAmount(amountss)
      setUsd(e.target.value)
      setMinValue(`maximum price is ${checked?`N${formatAmount(5000*buyRate)}`:"$5,000"}`)
      setMin(true)
    }
    else if((!checked && e.target.value  < 500) || (checked && e.target.value < (500*buyRate))){
      setAmount("")
      setUsd(e.target.value)
      setMinValue(`minimum price is ${checked?`N${formatAmount(500*buyRate)}`:"$500"}`)
      setMin(true)
    }
    else {
      // let value = parseInt(amountss)
      setAmount(amountss)
      setUsd(e.target.value)
      setTotalAmount(e.target.value)
      setMin(false)
      setMinValue("")
    }
  }
  }

  const onUSdChange = (e)=>{
    if(!isNaN(e.target.value)){
      let amountss = checked?Math.round((e.target.value*apiValue)*buyRate):Math.round(e.target.value*apiValue)
     if((!checked && amountss > 5000) || (checked && amountss > (5000*buyRate))){
      setAmount(e.target.value)
      setUsd(amountss)
      setMinValue(`maximum price for a guest is ${checked?`N${formatAmount(5000*buyRate)}`:"$5000"}`)
      setMin(true)
    }
    else if((!checked && amountss  < 500) || (checked && amountss < (500*buyRate))){
      setAmount(e.target.value)
      setUsd("")
      setMinValue(`minimum price for a guest is ${checked?`N${formatAmount(500*buyRate)}`:"$500"}`)
      setMin(true)
    }
    else {
      let value = parseInt(amountss)
      setAmount(e.target.value)
      setUsd(amountss)
      setTotalAmount(value)
      setMin(false)
      setMinValue("")
    }
  }
}

const handleSubmit = () =>{
    if(!usd || !amount || !email)
    enqueueSnackbar("All fields are required", {
      variant: "error",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    })
    else if((!checked && usd < 500) || (checked && usd < 500*buyRate))
    enqueueSnackbar(`minimum price for a guest is ${checked?`N${formatAmount(500*buyRate)}`:"$500"}`, {
      variant: "error",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    })
    else if((!checked && usd > 5000) || (checked && usd > (5000*buyRate)))
    enqueueSnackbar(`maximum price for a guest is ${checked?`N${formatAmount(5000*buyRate)}`:"$5000"}`, {
      variant: "error",
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "right",
      },
    })
    else
    setProceed(true)
}
function backk() {
  if (proceed) {
    setProceed(false);
  } else {
    props.history.push("/exchange");
  }
}

const year = new Date().getFullYear();

  return (
    <div className="container">
        <div className="d-flex justify-content-between w-100 row">
        <div className="bts-exchange-page-caption-section">
            <div className="bts-landing-left-menu px-0">
                <div className="bts-landing-page-caption-logo">
                <Link to="/">
                    <img src={Logo} alt=""/>
                </Link>
                </div>
            </div>        
        </div>
        <div className="d-flex align-items-center d-sm-none d-md-flex">
        <BTCRate/>

        </div>
        <div className="d-flex align-items-center">
           
                    <Link to="/login" className="blueText mr-3">Login</Link>
                    <Link to="/register" className="blueText">Register</Link>
                
            {/* <BTCRate/> */}
        </div>
        </div>
    <div className="px-0">
    
    <div className="bts-exchange-page-caption-section row">
                <Col md={2} className="mx-0 px-0">
                    <div className="bts-placeholder  d-flex justify-content-center align-items-center">
                        G
                    </div>
                </Col>
                <Col md={9} className="mx-0 px-0">
                <div className="">
                  
                        <p className="bts-welcome-text mt-3">You are welcome, Guest</p>
                        </div>
                </Col>
                <Col md={12} className="px-0 mx-0 mt-3">
                  <span className="blueText cursor" onClick={backk}>
                  <img src={back} alt="" className="blueText" />
                  Back
                </span>
               </Col>
               </div>
          <Row className="justify-content-center">
                <Col md={9}>
                    <div className="pt-4">
      {!proceed ? (
        <Fade>
          <div className="mb-5 buy-container">
            <div>
              <ItemWrapper
                id={currency.id}
                src={currency.src}
                name={currency.name}
                brate={rates.length >0 ?rates[0].Buy:""}
                srate={rates.length >0 ?rates[0].Sell:""}
                key={currency.id}
                available="false"
                img={currency.img}
              />
            </div>
            <div>
              <div>
                <div className="m-auto bts-settings-wrapper">
                <div className="d-flex align-items-center justify-content-between">
                  <p className="med blueText b7">Sell</p>
                  <div className="d-flex" style={{backgroundColor: "#EDF1F9"}}>
                 <select onChange={(e)=>onSwitch(e)} className="trans-select">
                    <option value="USD">USD</option>
                    <option value="NGN">NGN</option>
                </select>
                 </div>
                  </div>
                  <form action="">
                    <Row>
                      <Col md={5} className="position-relative">
                      <input type="text" onChange={onUSdChange} value={amount} placeholder={currency.short} />
                        {/* <span className="smallText lightBlue b5 position-absolute input-details">
                          {amount}
                        </span> */}
                      </Col>
                      <Col md={2} className="d-flex align-items-center">
                        <FiArrowUpRight className="lightBlue" />
                        <FiArrowDownLeft className="blueText" />
                      </Col>
                      <Col md={5}>
                      <span className="smallText lightBlue b5 position-absolute input-details">
                          {checked?"N" : "$"}
                        </span>
                        <input type="text" onChange={handleUsdChange} value={usd} placeholder={checked?"NGN":"USD"} />
                      </Col>
                    </Row>
                        <div className="my-2">
                        <input type="email" onChange={(e)=>setEmail(e.target.value)} value={email} placeholder="Email" />
                        </div>
                    <div className="justify-content-between py-2 my-3 px-2 border-rad bts-coin-rates d-flex whiteText">
                      <span className="lightText">We'll pay you</span>
                      <span className="blueText font-weight-bold">{checked?`N${formatAmount(totalAmount)}`:`N${formatAmount(Math.round(totalAmount*buyRate))}`}</span>
                    </div>
                  </form>
                  {
                          min && <p className="text-center m-0" style={{color:"red"}}>{minValue}</p>
                        }
                </div>
                <div className="py-2 buy-wrapper px-4">
                  <button onClick={handleSubmit} className="w-100">
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Fade>
      ) : (
        <SellCheckOut banks={banks} proceed={proceed} setProceed={setProceed} type={currency.short} usd={usd} amount={amount} totalAmount={checked?`N${formatAmount(totalAmount)}`:`N${formatAmount(Math.round(totalAmount*buyRate))}`} checked={checked} barcode={currency.barcode} walletAddress={currency.address} />
      )}
    </div>
                </Col>
            </Row>
        </div>
        <Container className="bts-exchange-footer px-5">
            <Row className="d-flex justify-content-between lightText">
                <section>
                    <span className="mail">Copyright  Bitmasta Inc.</span><br/>
      <span className="mail">All Rights Reserved {year}</span>
                </section>
                <section>
                    <span className="">
                      <TAC />
                    </span>
                </section>
            </Row>
        </Container>
      </div>
  );
};

export default TradeSell;
